// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","profileSectionVisbilityTag":"_1XBcYpjLme4Fp7FfI56PQM"};